
import XButton from 'vux/src/components/x-button/index.vue'
import Box from 'vux/src/components/box/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'

import IndexHeader from '@/components/IndexHeader'
import IndexSidebar from '@/components/IndexSidebar'
import IndexFooter from '@/components/IndexFooter'

export default {
data () {
return {
iconType: true,
advantageList: [
{
iconClass: 'toufangjingzhun',
imgSrc: 'https://static.xinmeibao.com/assets_mobile/v1/promo-wechat-effect-product-ad1.png',
h3Title: '投放精准',
description: '可基于公众号粉丝性别、类别属性、历史阅读等多维度设定投放条件。'
},
{
iconClass: 'baojiaguifan',
imgSrc: 'https://static.xinmeibao.com/assets_mobile/v1/promo-wechat-effect-product-ad2.png',
h3Title: '报价规范',
description: '广告主可以统一出价和根据实际投放提价，结算按照实际阅读计，成本控制大幅优于传统投放。'
},
{
iconClass: 'puguanggaoxiao',
imgSrc: 'https://static.xinmeibao.com/assets_mobile/v1/promo-wechat-effect-product-ad3.png',
h3Title: '曝光高效',
description: '15万媒体主在线抢单，快速触达千万粉丝。'
},
{
iconClass: 'xingshiduoyang',
imgSrc: 'https://static.xinmeibao.com/assets_mobile/v1/promo-wechat-effect-product-ad4.png',
h3Title: '形式多样',
description: '广告形式多样，包括微信图文、小程序图文、文中贴片三种广告形式。'
}
]
}
},
methods: {},
components: {
XButton,
Box,
Grid,
GridItem,
IndexHeader,
IndexSidebar,
IndexFooter
}
}



// WEBPACK FOOTER //
// ./src/pages/promotionWechatEffect/index.vue